import {Component, Input} from '@angular/core';

@Component({
    selector: 'db-single-page-generation-step',
    templateUrl: './single-page-generation-step.component.html',
    styleUrl: './single-page-generation-step.component.scss',
    standalone: false
})
export class SinglePageGenerationStepComponent {
  generationSteps = [
    {
      "label": "Preparing layout",
      "status": "process"
    },
    {
      "label": "Generating the content of the page",
      "status": "todo"
    },
    {
      "label": "Generating the images of the page",
      "status": "todo"
    },
    {
      "label": "Making your page mobile friendly",
      "status": "todo"
    },
    {
      "label": "Finalizing",
      "status": "todo"
    },
  ];
  @Input() isMobile: boolean = false;
}
